import { PermissionService } from '../../core/services/permission.service';
import { PermissionBit } from '../../core/utils/permission-types';

/**
 * A menu item needs one permission, any one of several, or a custom check.
 *
 * The predicate form exists for the items whose visibility depends on more than
 * the permission bits - the Pool, for instance, is also open to the managers who
 * are confined to their own practice.
 */
export type MenuPermission =
  | PermissionBit
  | readonly PermissionBit[]
  | ((permissionService: PermissionService) => boolean);

export function hasMenuPermission(permissionService: PermissionService, permission: MenuPermission): boolean {
  if (typeof permission === 'function') {
    return permission(permissionService);
  }
  if (Array.isArray(permission)) {
    return permissionService.hasAnyPermission(permission as readonly PermissionBit[]);
  }
  return permissionService.hasPermission(permission as PermissionBit);
}
